import { Esito } from '../../../models/esito';

export class EsitoAdapter {

  esito: Esito = new Esito();

  constructor(esito: Esito) {
    this.esito.id = esito.id;
    this.esito.tipoEsito = esito.tipoEsito ?  JSON.parse(JSON.stringify(esito.tipoEsito)) : null;
    this.esito.documenti = esito.documenti ? esito.documenti : [];
    this.esito.esitoPerSocieta = esito.esitoPerSocieta ?  JSON.parse(JSON.stringify(esito.esitoPerSocieta)) : null;
    this.esito.numeroEsito = esito.numeroEsito ;
    this.esito.numeroProtocollo = esito.numeroProtocollo;
    this.esito.definitivo = esito.definitivo ? esito.definitivo : false ;
    this.esito.annoEsito = esito.annoEsito ;
    this.esito.dataDeposito = esito.dataDeposito ;
    this.esito.dataNotifica = esito.dataNotifica ;
    //this.esito.classificazioni = esito.classificazioni ? esito.classificazioni : [];
    //this.esito.controparti = esito.controparti ? esito.controparti : [];
    this.esito.dataImpugnazione = esito.dataImpugnazione ;
    this.esito.dataPubblicazione = esito.dataPubblicazione;
    this.esito.note = esito.note ;
    this.esito.dettagliEsito = esito.dettagliEsito ? esito.dettagliEsito : [];
    this.esito.societa = esito.societa;
    this.esito.liquidati = esito.liquidati ? esito.liquidati : [];
    this.esito.dataTrasmissioneSentenza = esito.dataTrasmissioneSentenza;
    this.esito.dataComunicazione = esito.dataComunicazione;
    this.esito.dataPronuncia = esito.dataPronuncia;
    this.esito.flagCondannaInSolido = esito.flagCondannaInSolido ? esito.flagCondannaInSolido : false;
    this.esito.flagRivalsa = esito.flagRivalsa ? esito.flagRivalsa : false;
    this.esito.dataIrrevocabilita = esito.dataIrrevocabilita;
  }
}
